import {Injectable} from '@angular/core';
import SceneStatisticsModel from '../../../models/scene-statistics.model';
import {MathService} from './math.service';

@Injectable({
    providedIn: 'root'
})
export class SceneMonitoringService {

    constructor(private mathService: MathService) {
    }

    public monitor(
        timeArray: number[],
        scenesStatistics: Array<SceneStatisticsModel>,
        measurementError: number,
        minTime: number
    ) {
        let timeEnd = 0;
        let timeStart = 0;
        let lastElement = 0;
        let firstWatchedSceneIndex;

        for (const timePoint of timeArray) {
            if (lastElement + measurementError < timePoint || lastElement > timePoint) {
                firstWatchedSceneIndex = scenesStatistics.findIndex((sceneStatistic) =>
                    sceneStatistic.time.start <= timeStart && sceneStatistic.time.end > timeStart);

                this.updateStatistics(firstWatchedSceneIndex, timeEnd, timeStart, scenesStatistics, minTime);

                timeStart = timePoint;
            }

            timeEnd = timePoint;
            lastElement = timePoint;
        }

        firstWatchedSceneIndex = scenesStatistics.findIndex((sceneStatistic) =>
            sceneStatistic.time.start <= timeStart && sceneStatistic.time.end > timeStart);

        if (firstWatchedSceneIndex !== -1) {
            this.updateStatistics(firstWatchedSceneIndex, timeEnd, timeStart, scenesStatistics, minTime);
        }

        return scenesStatistics;
    }

    private updateStatistics(
        beginIndex: number,
        endTime: number,
        startTime: number,
        scenesStatistics: Array<SceneStatisticsModel>,
        minTime: number
    ) {
        if (beginIndex < 0) {
            return;
        }

        const sceneTimeEnd = scenesStatistics[beginIndex].time.end;

        if (sceneTimeEnd < endTime) {
            const watchedSceneTime = this.mathService.roundTo2DecimalPlaces(sceneTimeEnd - startTime);

            if (watchedSceneTime >= minTime) {
                scenesStatistics[beginIndex].totalTimeWatched.push(watchedSceneTime);
            }

            if (beginIndex + 1 < scenesStatistics.length) {
                this.updateStatistics(beginIndex + 1, endTime, sceneTimeEnd, scenesStatistics, minTime);
            }

        } else {
            const watchedSceneTime = this.mathService.roundTo2DecimalPlaces(endTime - startTime);

            if (watchedSceneTime >= minTime) {
                scenesStatistics[beginIndex].totalTimeWatched.push(watchedSceneTime);
            }
        }

        return;
    }
}
